"use client";

import CoachingBriefWidget from "./CoachingBriefWidget";
import PatternSummaryWidget from "./PatternSummaryWidget";
import CheckInButton from "./CheckInButton";

/**
 * Shared cluster of manager coaching actions for a single teammate:
 * "Prep for 1:1" (LLM coaching brief), "Analyze Patterns" (cross-session
 * analysis), and an optional one-click check-in. Each child owns its own
 * fetch/loading state, so this is purely layout. Used in the manager
 * dashboard's expanded rep row and the person detail page to keep the
 * coaching toolkit identical across surfaces.
 *
 * Brief and pattern widgets each expand from a button into a full-width panel,
 * so they're stacked vertically to stay clean in both states. `showCheckIn`
 * defaults true; pass false where a check-in already lives elsewhere on the
 * page (e.g. the person page's attention banner).
 */
export default function CoachingActions({
  userId,
  userName,
  workspaceId,
  timeframeDays,
  dateRange,
  tag = "warn",
  showCheckIn = true,
}) {
  // dateRange ({ timeframeDays } or { startDate, endDate, timezone }) wins over
  // the legacy timeframeDays prop, which existing call sites still pass.
  const range = dateRange || { timeframeDays };
  // flex-wrap with a gap keeps the collapsed triggers spaced in a toolbar row;
  // each widget's expanded panel is w-full, so it drops onto its own line.
  return (
    <div className="flex flex-wrap items-start gap-2">
      {showCheckIn && (
        <CheckInButton userId={userId} name={userName} tag={tag} />
      )}
      <CoachingBriefWidget
        userId={userId}
        userName={userName}
        workspaceId={workspaceId}
        dateRange={range}
      />
      <PatternSummaryWidget
        userId={userId}
        workspaceId={workspaceId}
        dateRange={range}
      />
    </div>
  );
}
